import { ANGEL_USER_DATE } from '@/constant/date'
import { User } from 'Types/user'
const adminUidEnds = [
  '11720301872636',
  '06240797762176',
  '16084536960845',
  '10560995309200',
]
export function isLikeAdmin(user: User | null): boolean {
  if (!user?.user_id) return false
  return adminUidEnds.includes(user.user_id?.slice(5))
}

export function isAngelUser(uid: string = String(Number.MAX_VALUE)): boolean {
  return Number(uid) / 1000000 < ANGEL_USER_DATE
}
